<script lang="ts">
  import { Grid, InlineNotification, Tile } from "carbon-components-svelte";
  import CommonSeal from "./components/categories/CommonSeal.svelte";
  import DateStamp from "./components/categories/DateStamp.svelte";
  import QrCode from "./components/categories/QRCode.svelte";
  import RubberStamp from "./components/categories/RubberStamp.svelte";
  import type APIClient from "./ts/APIClient";
  import type { ICanvas } from "./ts/Interfaces";
  import NameBadges from "./components/categories/NameBadges.svelte";

  export let client: APIClient;
  export let canvas: ICanvas;
</script>

{#if !canvas.stampCategory}
  <Grid noGutter>
    <Tile>
      <InlineNotification
        hideCloseButton
        kind="error"
        title="Error Loading Wizard"
        subtitle="Stamp Category Missing! Please try reloading the page."
      />
    </Tile>
  </Grid>
{/if}

{#if canvas.stampCategory === "QR Code"}
  <QrCode {canvas} {client} />
{/if}

{#if canvas.stampCategory === "Rubber Stamp"}
  <RubberStamp {canvas} {client} />
{/if}

{#if canvas.stampCategory === "Date Stamp"}
  <DateStamp {canvas} {client} />
{/if}

{#if canvas.stampCategory === "Common Seal"}
  <CommonSeal {canvas} {client} />
{/if}

{#if canvas.stampCategory === "Name Badges"}
  <NameBadges {canvas} {client} />
{/if}
